<template>
  <div v-if="false">PromotionalArea</div>
</template>

<script>
export default {};
</script>

<style></style>
